import React from 'react'
import { useState, useEffect } from 'react';
import Tablecommande from './component/tablecommande';
import Sidebar from './component/Sidebar';
import AdminUserBadge from './component/AdminUserBadge';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
function Home(){


  var urlshecktableau1 ="https://jojomarket.org/adminfood/tableau.php";

 
  const[shecktableau, setShecktableau] = useState([]);
  const loadSheckTableau = async(urlshecktableau)=>{
    const responsesheck = await axios.get(urlshecktableau);
    setShecktableau(responsesheck.data);
  }
  const navigate = useNavigate ();
  const cheklogin =()=> {
    
      if(!sessionStorage.getItem("Token")){
      //const history = useHistory();
      //sessionStorage.setItem("Token");
      //toast.success('Bienvenue');
      
      
      navigate('/login');
  
     
  }}

useEffect(()=>{
  var test = cheklogin();
  var urlshecktableau1 ="https://jojomarket.org/adminfood/tableau.php";

   loadSheckTableau(urlshecktableau1); 
 }, []);

  return (
    <div> 
  <Sidebar/>
  <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
    {/* Navbar */}
    <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
      <div className="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="javascript:;">Accueil</a></li>
            <li className="breadcrumb-item text-sm text-dark active" aria-current="page">Commande</li>
          </ol>
          <h6 className="font-weight-bolder mb-0">Gestion Commande</h6>
        </nav>
        <div className="collapse justify-content-end navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
          <ul className="navbar-nav justify-content-end align-items-center">
            <AdminUserBadge className="me-3" />
            <li className="nav-item d-flex align-items-center">
              <Link to="/login" className="nav-link text-body font-weight-bold px-0">
                <i className="fa fa-user me-sm-1" />
                <span className="d-sm-inline d-none">Deconnexion</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    {/* End Navbar */}
    
    <div className="container-fluid py-4">
    {shecktableau && shecktableau.map((item,index) => (
      <div className="row">
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-capitalize font-weight-bold">Commande Total</p><br/>
                    <h5 className="font-weight-bolder mb-0">
                      {item.nbrtotalcommande}
                      <span className="text-success text-sm font-weight-bolder"></span>
                    </h5>
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                    <i className="ni ni-money-coins text-lg opacity-10" aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-capitalize font-weight-bold">Commande En cours</p>
                    <h5 className="font-weight-bolder mb-0">
                    {item.nbrtotalencours}
                      <span className="text-success text-sm font-weight-bolder"></span>
                    </h5>
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                    <i className="ni ni-world text-lg opacity-10" aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6 mb-xl-0 mb-4">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-capitalize font-weight-bold">Montant Total Encaisser </p>
                    <h5 className="font-weight-bolder mb-0">
                    {item.montanttotalencaisse}
                      <span className="text-danger text-sm font-weight-bolder"></span>
                    </h5>
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                    <i className="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-sm-6">
          <div className="card">
            <div className="card-body p-3">
              <div className="row">
                <div className="col-8">
                  <div className="numbers">
                    <p className="text-sm mb-0 text-capitalize font-weight-bold">Commande Non Encaisser</p>
                    <h5 className="font-weight-bolder mb-0">
                   {item.montanttotalnonencaisse}
                      <span className="text-success text-sm font-weight-bolder"></span>
                    </h5>
                  </div>
                </div>
                <div className="col-4 text-end">
                  <div className="icon icon-shape bg-gradient-primary shadow text-center border-radius-md">
                    <i className="ni ni-cart text-lg opacity-10" aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
      <Tablecommande/>
     
      <footer className="footer pt-3  ">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-start">
                © H2A.
              </div>
            </div>
        
          </div>
        </div>
      </footer>
    </div>
  </main>
  <div className="fixed-plugin">
   
    <div className="card shadow-lg ">
      <div className="card-header pb-0 pt-3 ">
        <div className="float-start">
          <h5 className="mt-3 mb-0">Soft UI Configurator</h5>
          <p>See our dashboard options.</p>
        </div>
        <div className="float-end mt-4">
          <button className="btn btn-link text-dark p-0 fixed-plugin-close-button">
            <i className="fa fa-close" />
          </button>
        </div>
        {/* End Toggle Button */}
      </div>
      <hr className="horizontal dark my-1" />
      <div className="card-body pt-sm-3 pt-0">
        {/* Sidebar Backgrounds */}
        <div>
          <h6 className="mb-0">Sidebar Colors</h6>
        </div>
        <a href="javascript:void(0)" className="switch-trigger background-color">
          <div className="badge-colors my-2 text-start">
            <span className="badge filter bg-gradient-primary active" data-color="primary" onClick="sidebarColor(this)" />
            <span className="badge filter bg-gradient-dark" data-color="dark" onClick="sidebarColor(this)" />
            <span className="badge filter bg-gradient-info" data-color="info" onClick="sidebarColor(this)" />
            <span className="badge filter bg-gradient-success" data-color="success" onClick="sidebarColor(this)" />
            <span className="badge filter bg-gradient-warning" data-color="warning" onClick="sidebarColor(this)" />
            <span className="badge filter bg-gradient-danger" data-color="danger" onClick="sidebarColor(this)" />
          </div>
        </a>
        {/* Sidenav Type */}
        <div className="mt-3">
          <h6 className="mb-0">Sidenav Type</h6>
          <p className="text-sm">Choose between 2 different sidenav types.</p>
        </div>
        <div className="d-flex">
          <button className="btn bg-gradient-primary w-100 px-3 mb-2 active" data-class="bg-transparent" onClick="sidebarType(this)">Transparent</button>
          <button className="btn bg-gradient-primary w-100 px-3 mb-2 ms-2" data-class="bg-white" onClick="sidebarType(this)">White</button>
        </div>
        <p className="text-sm d-xl-none d-block mt-2">You can change the sidenav type just on desktop view.</p>
        {/* Navbar Fixed */}
        <div className="mt-3">
          <h6 className="mb-0">Navbar Fixed</h6>
        </div>
        <div className="form-check form-switch ps-0">
          <input className="form-check-input mt-1 ms-auto" type="checkbox" id="navbarFixed" onClick="navbarFixed(this)" />
        </div>
        <hr className="horizontal dark my-sm-4" />
        <a className="btn bg-gradient-dark w-100" href="https://www.creative-tim.com/product/soft-ui-dashboard">Free Download</a>
        <a className="btn btn-outline-dark w-100" href="https://www.creative-tim.com/learning-lab/bootstrap/license/soft-ui-dashboard">View documentation</a>
        <div className="w-100 text-center">
          <a className="github-button" href="https://github.com/creativetimofficial/soft-ui-dashboard" data-icon="octicon-star" data-size="large" data-show-count="true" aria-label="Star creativetimofficial/soft-ui-dashboard on GitHub">Star</a>
          <h6 className="mt-3">Thank you for sharing!</h6>
          <a href="https://twitter.com/intent/tweet?text=Check%20Soft%20UI%20Dashboard%20made%20by%20%40CreativeTim%20%23webdesign%20%23dashboard%20%23bootstrap5&url=https%3A%2F%2Fwww.creative-tim.com%2Fproduct%2Fsoft-ui-dashboard" className="btn btn-dark mb-0 me-2" target="_blank">
            <i className="fab fa-twitter me-1" aria-hidden="true" /> Tweet
          </a>
          <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.creative-tim.com/product/soft-ui-dashboard" className="btn btn-dark mb-0 me-2" target="_blank">
            <i className="fab fa-facebook-square me-1" aria-hidden="true" /> Share
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
export default Home;